import { DEFAULT_LOCALE } from './constants';

export function formatFloatAsPercent(percentage: number, options: Intl.NumberFormatOptions = {}) {
  return percentage.toLocaleString(DEFAULT_LOCALE, { ...options, style: 'percent' });
}
